import type {
    CreateCommerceShareResourceRequest,
    CreateCommerceShareResourceResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const createCommerceShareResourceOperation = defineCommerceOperation<
    CreateCommerceShareResourceRequest,
    CreateCommerceShareResourceResponse
>("commerce.share.create");
